import ClassicEditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor'
import Lang from './Lang'

export default class Editor {
    #completeConfig = {
        toolbar: {
            items: [
                'heading',
                '|',
                'bold',
                'italic',
                '|',
                'link',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'insertTable',
                '|',
                'blockQuote',
                '|',
                'undo',
                'redo',
            ],
        },
        heading: {
            options: [
                {
                    model: 'paragraph',
                    title: Lang.get('general.text'),
                    class: 'ck-heading_paragraph',
                },
                {
                    model: 'heading3',
                    view: 'h3',
                    title: Lang.get('general.header'),
                    class: 'ck-heading_heading3',
                },
            ],
        },
    }
    #minimalConfig = {
        toolbar: {
            items: ['bold', 'italic', '|', 'link', '|', 'undo', 'redo'],
        },
    }

    constructor(element) {
        let style = element.dataset.gpEditor ?? 'complete'
        let config = style === 'minimal' ? this.#minimalConfig : this.#completeConfig

        ClassicEditor.create(element, config)
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Editor(element))
    }
}
